import { ChangeDetectionStrategy, Component, input, output, signal, viewChild, ViewEncapsulation } from '@angular/core';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatListItemIcon, MatListItemTitle, MatListOption, MatSelectionList } from '@angular/material/list';
import { MatMenu, MatMenuContent, MatMenuTrigger } from '@angular/material/menu';

import { ClickStopPropagationDirective, EnterStopPropagationDirective, SpaceStopPropagationDirective } from '../../directives/stop-propagation';
import { IconComponent } from '../icon/icon';

@Component({
    selector: 'st-assignment-creation-menu',
    imports: [
        ClickStopPropagationDirective,
        EnterStopPropagationDirective,
        IconComponent,
        MatIcon,
        MatIconButton,
        MatListItemIcon,
        MatListItemTitle,
        MatListOption,
        MatMenu,
        MatMenuContent,
        MatMenuTrigger,
        MatSelectionList,
        SpaceStopPropagationDirective,
    ],
    templateUrl: './assignment-creation-menu.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: {
        class: 'st-assignment-creation-menu',
    },
})
export class AssignmentCreationMenuComponent {
    readonly types = input<LookupValue[]>([]);
    readonly disabled = input<boolean>(false);
    readonly dir = input<'ltr' | 'rtl'>('ltr');

    readonly typesSelected = output<string[]>();

    private readonly trigger = viewChild<MatMenuTrigger>('menuTrigger');
    private readonly selectionList = viewChild<MatSelectionList>('selectionList');
    private readonly selected = signal<string[]>([]);

    onSelectionChange(list: MatSelectionList) {
        this.selected.set(list.selectedOptions.selected.map(o => o.value as string));
    }

    onMenuOpened() {
        this.selectionList()?.options.first?.focus();
    }

    onMenuClosed() {
        const picked = this.selected();
        this.selected.set([]);
        if (picked?.length) {
            this.typesSelected.emit(picked);
        }
    }

    onTriggerArrowDown() {
        this.selectionList()?.options.first?.focus();
    }

    onTriggerArrowUp() {
        this.selectionList()?.options.last?.focus();
    }

    onTabKeydown(event: Event) {
        this.trigger()?.closeMenu();
        event.preventDefault();
        event.stopPropagation();
    }
}
